module.exports = __webpack_public_path__ + "img/datacenter_pic1.7f64de3c.jpg";